// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field-title[data-v-2d284598]{font-size:18px;overflow:visible}.field-title.group-title[data-v-2d284598]{font-size:14px}.field-help-text[data-v-2d284598]{margin:0;margin-left:calc(1.45rem + .5em)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
